<template>
  <div
    ref="printKGIBillDom"
    class="pageWrap"
    :class="{'preview': isPreview}"
  >
    <div
      v-for="(val, ind) in billData"
      :key="ind"
      class="page"
    >
      <div class="wrap top">
        <h1>{{ feeType === 'other-management' ? '社區' : '管理費' }}繳費通知</h1>
        <h2>{{ val.BillBulkName }}</h2>
        <div class="communityDetail">
          <p class="name">
            {{ val.CommitteeName }}
          </p>
          <p class="address">
            {{ val.CommitteeAddress }}
          </p>
          <p class="phone">
            {{ val.CommitteeTel }}
          </p>
        </div>
        <div class="stamp">
          <div class="psText">
            <!-- <p>國　　內</p>
            <p>郵資已付</p> -->
          </div>
        </div>
        <div class="orderDetail">
          <div class="qrcodeArea">
            <img
              src="@/assets/img/print/300X75.png"
              alt=""
            >
            <vue-qr
              :ref="`code_${val.BillId}`"
              :callback="isImageGenerate"
              :correct-level="0"
              :dot-scale="1"
              :qid="val.BillId.toString()"
              :logo-src="require('@/assets/img/print/logoInside.png')"
              :text="`https://access.smartdaily.com.tw/launchApp.html?page=bill${ isPreview ? '' : ('&param=' + val.BillId) }`"
              :margin="5"
              :logo-background-color="'#fff'"
              :logo-margin="5"
              :size="200"
            />
            <span>掃描開啟App<br>線上完成繳費</span>
          </div>
          <p class="address">
            {{ val.Address || val.TabletNote }}
          </p>
          <p class="order">
            <span class="name">{{ val.Owner }}</span>
            <span class="salutation">先生 / 小姐 / 寶號</span>
          </p>
        </div>
        <p class="deadline">
          <span>繳款期限 : {{ val.DueDate }}</span>
        </p>
        <div class="noticePs">
          <span class="title">備註</span>
          <p class="text">
            {{ val.BillBulkNote }}
          </p>
        </div>
      </div>
      <div class="wrap center">
        <div class="feePayWrap">
          <ul class="feeTitle">
            <li>
              戶別代碼：
              <span class="feeCode">{{ val.TabletNote }}</span>
            </li>
            <li>姓　　名： <span class="name">{{ val.Owner }}</span></li>
            <li>
              期　　別： <span class="feeDate">{{ val.BillBulkName }}</span>
            </li>
          </ul>
          <div class="detailWrap">
            <span class="itemTitle">繳費項目</span>
            <span class="cashTitle">金　　額</span>
            <div class="clearfix" />
            <div class="itemWrap">
              <p
                v-for="(v, i) in val.BillTerms"
                :key="i"
              >
                <span class="item">{{ v.Name }}</span>
                <span class="cash">{{ thousandComma(v.Amount) }}</span>
              </p>
            </div>
            <div class="itemTotal">
              <p>
                <span class="totalTitle">應繳金額</span>
                <span class="totalCash">NT$ <span>{{ thousandComma(val.ShouldAmount) }}</span></span>
              </p>
              <p>
                <span class="totalTitle">新台幣</span>
                <span class="totalCash"><span>{{ numberToChinese(val.ShouldAmount) }}元整</span></span>
              </p>
            </div>
          </div>
        </div>
        <div class="connectWrap">
          <h3>通訊欄</h3>
          <div class="connectText">
            <p>{{ val.BillBulkCommunicationBar }}</p>
            <p>{{ val.CommunicationBar }}</p>
          </div>
          <div class="adWrap">
            <img
              src="@/assets/img/print/300X75.png"
              alt=""
            >
          </div>
        </div>
        <p class="pageText">
          第一聯 ：收執聯 ，繳款人留存
        </p>
      </div>
      <div class="wrap bottom">
        <div class="payCodeWrap">
          <div class="formWrap">
            <p class="bankNotice">
              <span class="bankNameArea"><span class="bankName" />銀行臨櫃匯款</span>
              <!-- <span style="display:block; margin-top: 3px">(注意！請勿拿過期繳款單繳交當期帳款，以免銷帳失敗)</span> -->
            </p>
            <p class="Superbusiness_title">
              繳款期限：{{ val.DueDate }}
              <!-- 7-ELEVEN、全家、萊爾富、OK<br />繳款金額以2萬元為限。 -->
            </p>
            <p />
            <div
              class="form"
              :class="{'noBarcode': true}"
            >
              <div class="feeData">
                <div v-if="!val.ATMBlockShow">
                  <div class="row noATM">
                    <div class="data">
                      <p>本期別不開放虛擬帳號臨櫃繳款及轉帳，<br>請打開App改用其他方式繳款。</p>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <p class="title">
                      匯款戶名
                    </p>
                    <div class="data">
                      凱基商業銀行受託信託財產專戶
                    </div>
                  </div>
                  <div class="row">
                    <p class="title">
                      繳款帳號
                    </p>
                    <div class="data virtualAccount">
                      <div
                        v-if="!val.VirtualAccount"
                        class="watermark"
                      >
                        範本
                      </div>
                      <span>{{ val.VirtualAccount||'00000000000000' }}</span>
                      <div class="codeArea">
                        <vue-barcode
                          :value="val.VirtualAccount || '00000000000000'"
                          :options="{ displayValue: false, format: 'CODE39' }"
                          tag="img"
                        />
                        <!-- <img
                          alt=""
                          :src="`https://aquarius.neweb.com.tw/CashSystemFrontEnd/BarcodeGenerator?barcode=${val.VirtualAccount||'00000000000000'}`"/> -->
                        <p>{{ val.VirtualAccount || '00000000000000' }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row price">
                    <p class="title">
                      繳款金額
                    </p>
                    <div class="data">
                      NT$ <span>{{ thousandComma(val.ShouldAmount + val.ATMAttachHandlingFee) }}</span>
                      <span v-if="val.ATMAttachHandlingFee > 0">(外加手續費${{ val.ATMAttachHandlingFee }}元)</span>
                      <div class="codeArea">
                        <vue-barcode
                          :value="(val.ShouldAmount + val.ATMAttachHandlingFee) > 0 ? (val.ShouldAmount + val.ATMAttachHandlingFee).toString() : '0'"
                          :options="{ displayValue: false, format: 'CODE39' }"
                          tag="img"
                        />
                        <!-- <img
                          :src="`https://aquarius.neweb.com.tw/CashSystemFrontEnd/BarcodeGenerator?barcode=${((val.ShouldAmount + val.ATMAttachHandlingFee) && (val.ShouldAmount + val.ATMAttachHandlingFee) > 0) || 0}`"/> -->
                        <p>$ {{ thousandComma(val.ShouldAmount + val.ATMAttachHandlingFee) }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <p class="title">
                      繳款人
                    </p>
                    <div class="data">
                      <span />
                      <span class="ownerWrap"><span class="owner">{{ val.Owner }} {{ val.TabletNote }}</span></span>
                    </div>
                  </div>
                </div>
                <div class="row certiWrap">
                  <p v-if="val.IsDynamicAccount && val.ATMBlockShow && val.ConvenientBlockShow">
                    <span>※此繳款帳號及便利商店條碼僅限本期使用，</span><span class="content-bold">請勿加入常用帳號或重複繳款。</span>
                  </p>
                  <p v-else-if="val.IsDynamicAccount && val.ATMBlockShow && !val.ConvenientBlockShow">
                    <span>※此繳款帳號僅限本期使用，</span><span class="content-bold">請勿加入常用帳號或重複繳款。</span>
                  </p>
                  <p v-else-if="val.IsDynamicAccount && !val.ATMBlockShow && val.ConvenientBlockShow">
                    <span>※此便利商店條碼僅限本期使用，</span><span class="content-bold">請勿重複繳款。</span>
                  </p>
                  <p v-if="val.ATMBlockShow">
                    ※⾦融機構匯款請依照上⽅填寫匯款⼾名及⾦額，另請載明：解款⾏【凱基銀⾏(809)】、分⾏【城東分⾏】。
                  </p>
                  <p v-if="val.BarcodeFeeModeName === 'Extra' && val.ConvenientBlockShow">
                    {{ $t('Fee.V4BillExtraNote') }}
                  </p>
                  <p v-if="!val.ATMBlockShow && !val.ConvenientBlockShow">
                    {{ $t('Fee.BillNoteEmpty') }}
                  </p>
                </div>
              </div>
              <div class="codeData">
                <span>便利商店專用條碼區</span>
                <div class="codeScan">
                  <div
                    v-if="!val.ConvenientBlockShow"
                    class="disablePattern"
                  >
                    (本期未開放超商條碼付款)
                  </div>
                  <div
                    v-else-if="val.ShouldAmount > 60000"
                    class="disablePattern"
                  >
                    <!-- 不含外加 不超過六萬塊可以繳費 -->
                    本期應繳總金額<br>
                    超過六萬不開放超商付款<br>
                    建議改用信用卡、ATM等<br>
                    其他方式付款
                  </div>
                  <div
                    v-else-if="val.ShouldAmount <= 10"
                    class="disablePattern"
                  >
                    本期應繳總金額>10元時<br>
                    開放使用超商付款<br>
                    請使用臨櫃或轉帳至繳費帳號
                  </div>
                  <template v-else>
                    <div
                      v-if="(!val.BillBarcode1 || !val.BillBarcode2 || !val.BillBarcode3)"
                      class="watermark"
                    >
                      範本
                    </div>
                    <div class="code">
                      <div class="codeRow">
                        <vue-barcode
                          :value="val.BillBarcode1 || '000000000'"
                          :options="{ displayValue: false, format: 'CODE39' }"
                          tag="img"
                        />
                        <p>{{ val.BillBarcode1 || '000000000' }}</p>
                        <div class="shouldPayMoney">
                          繳款金額：<br>
                          <p>NT＄{{ thousandComma(val.ShouldAmount + val.ConvenientAttachHandlingFee) }}</p>
                          <p v-if="val.ConvenientAttachHandlingFee > 0">
                            (外加手續費${{ val.ConvenientAttachHandlingFee }}元)
                          </p>
                        </div>
                      </div>
                      <div class="codeRow">
                        <vue-barcode
                          :value="val.BillBarcode2 || '000000000'"
                          :options="{ displayValue: false, format: 'CODE39', width: 3 }"
                          tag="img"
                        />
                        <p>{{ val.BillBarcode2 || '0000000000000000' }}</p>
                      </div>
                      <div class="codeRow">
                        <vue-barcode
                          :value="val.BillBarcode3 || '000000000'"
                          :options="{ displayValue: false, format: 'CODE39', width: 3 }"
                          tag="img"
                        />
                        <p>{{ val.BillBarcode3 || '0000000000000000' }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="clearfix" />
            </div>
          </div>
          <p class="pageText">
            第二聯 ：存根聯 ，代收行留存
          </p>
          <p class="clearfix" />
          <p
            v-if="val.ATMBlockShow"
            class="tip"
          >
            ATM/網路銀行繳款流程
            <!-- (請勿將此帳號加入常用帳號，因為每期銷帳帳號皆不相同，以免銷帳失敗) -->
          </p>
        </div>
        <div
          v-if="val.ATMBlockShow"
          id="stepWrap0"
          class="stepWrap"
        >
          <div class="stepArea">
            <p>※請選擇【轉帳】或【繳費】→銀行代碼【809】→【繳款帳號及金額】，請注意非約定轉帳有單筆最高金額限制</p>
          </div>
          <!-- <div class="step">
            <p>●插入金融卡</p>
            <p>輸入金融卡號碼</p>
          </div>
          <span class="pass">-&gt;</span>
          <div class="step">
            <p>●選擇</p>
            <p>繳費功能</p>
          </div>
          <span class="pass">-&gt;</span>
          <div class="step">
            <p>●輸入銀行</p>
            <p>代號 <span>807</span></p>
          </div>
          <span class="pass">-&gt;</span>
          <div class="step">
            <p>●輸入繳款帳號</p>
            <p>{{ val.VirtualAccount }}</p>
          </div>
          <span class="pass">-&gt;</span>
          <div class="step">
            <p>●輸入繳款金額</p>
            <p>NT$ <span>{{ thousandComma(val.ShouldAmount) }}</span></p>
          </div>
          <span class="pass">-&gt;</span>
          <div class="step">
            <p>●交易完成，請保留明細表已確認轉帳是否成功。</p>
          </div> -->
        </div>
        <!-- <p class="signArea">
          主管<span></span>會計 <span></span>覆核 <span></span>記帳 <span></span>
        </p> -->
        <!-- <p class="copyright">
          即時入金自動化對帳服務系統 Powered By
          <img src="@/assets/img/print/300X75.png" alt="" />
          <span></span>
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
export default {
  components: {
    'vue-barcode': VueBarcode
  },
  props: {
    isPreview: Boolean
  },
  data () {
    return {
      billData: [],
      qrcodeImage: [],
      configData: null,
      feeType: 'management'
    }
  },
  mounted () {
    this.feeType = this.$route.params.type
  },
  methods: {
    isImageGenerate (data, id) {
      // console.log(data)
      // console.log(id)
    },
    print () { // 列印
      this.$print(this.$refs.printKGIBillDom)
    },
    getBillData (bulkId, billId) { // 取得繳費單
      const loading = this.$loading()
      if (this.isPreview) { // 預覽繳費單
        apiBillserviceKGI.Config.GetCommunitySettingForm(
        ).then((res) => {
          console.log(res)
          try {
            this.configData = res.data
            this.billData = [{
              BillId: 0,
              BillBulkName: '2018年05~07月超商測試',
              BillBulkCommunicationBar: this.configData.CommunicationBar,
              BillBulkNote: this.configData.Note,
              CommitteeName: this.configData.CommitteeName,
              CommitteeAddress: this.configData.CommitteeAddress,
              CommitteeTel: this.configData.CommitteeTel,
              CommunicationBar: '',
              DueDate: '2018/06/30',
              Owner: '管理室測試繳費',
              Address: '超商繳費測試',
              TabletNote: '管理室',
              ShouldAmount: 300,
              BillBarcode1: '0706306W7',
              BillBarcode2: '00777000070400126',
              BillBarcode3: '063076000000003',
              VirtualAccount: '77900070000128',
              BillTerms: [
                { Name: '前期補收', Amount: 100 },
                { Name: '管理費5-7月', Amount: 100 },
                { Name: '車位清潔費', Amount: 100 }
              ],
              ConvenientBlockShow: this.configData.ConfigPayWays.some((val) => {
                // eslint-disable-next-line eqeqeq
                return val.Id == 2 && val.Switch
              }),
              // eslint-disable-next-line eqeqeq
              ConvenientAttachHandlingFee: (this.configData.BarcodeFeeModeName == '外加' && this.configData.BarcodeFeeMode) ? this.configData.BarcodeFee : 0,
              ATMBlockShow: this.configData.ConfigPayWays.some((val) => {
                // eslint-disable-next-line eqeqeq
                return (val.Id == 1 && val.Switch)
              }),
              ATMAttachHandlingFee: 0
            }]
          } catch (e) {
            console.log(e)
          }

          loading.close()
        }).catch((err) => {
          console.log(err.response)
          loading.close()
          this.$message({
            message: '取得繳費單基本設定失敗，請稍後再試',
            type: 'warning'
          })
        })
      } else { // 列印繳費單
        console.log(billId)
        const requestData = {
          Ids: billId
        }
        apiBillserviceKGI.Bill.PutBillPrint(
          requestData
        ).then((res) => {
          console.log(res)
          // const { BillBulkName, BillBulkCommunicationBar, BillBulkNote, CommitteeName, CommitteeAddress, CommitteeTel, Bills, ConfigPayWays} = res.data
          const billBulks = res.data.BillBulks
          this.billData = []
          billBulks.forEach((billBulk) => {
            const { BillBulkName, BillBulkCommunicationBar, BillBulkNote, CommitteeName, CommitteeAddress, CommitteeTel, Bills, ConfigPayWays } = billBulk
            this.billData.push(...Bills.map((e) => {
              e.BillBulkName = BillBulkName
              e.BillBulkCommunicationBar = BillBulkCommunicationBar
              e.BillBulkNote = BillBulkNote
              e.CommitteeName = CommitteeName
              e.CommitteeAddress = CommitteeAddress
              e.CommitteeTel = CommitteeTel
              e.BillBarcode1 = e.PaperBarcode1
              e.BillBarcode2 = e.Barcode2
              e.BillBarcode3 = e.PaperBarcode3
              // 超商
              e.ConvenientBlockShow = ConfigPayWays.some((val) => val.ConfigPayWayId === 2)
              // eslint-disable-next-line eqeqeq
              e.ConvenientAttachHandlingFee = (e.BarcodeFeeModeName == 'Extra' && e.BarcodeFeeMode) ? e.BarcodeFee : 0
              // atm 臨櫃
              e.ATMBlockShow = ConfigPayWays.some((val) => val.ConfigPayWayId === 1) && e.CanUseAtmPayWay
              e.ATMAttachHandlingFee = 0
              // 帳單到期日
              e.DueDate = this.$formatDate(e.DueDate)
              return e
            }))
          })
          // this.$nextTick(()=>{
          //   this.print()
          // })
          setTimeout(() => {
            this.print()
            loading.close()
          }, (3000 + this.billData.length * 30))
        }).catch((err) => {
          console.log(err.response)
          loading.close()
          let errorMsg = ''
          // eslint-disable-next-line eqeqeq
          if (err.response?.data?.ErrorCode == 404001) {
            errorMsg = '期別不存在'
          // eslint-disable-next-line eqeqeq
          } else if (err.response?.data?.ErrorCode == 404002) {
            errorMsg = '繳費單不存在'
          } else {
            errorMsg = '取得繳費單列印資訊失敗，請稍後再試'
          }
          this.$message({
            message: errorMsg,
            type: 'warning'
          })
        })
      }
    },
    thousandComma (number) { // 產出金額三位逗號
      let num = number.toString()
      const pattern = /(-?\d+)(\d{3})/
      // 整數 [0-9]+ = \d+
      // ?  匹配前面的子運算式零次或一次。例如，“do(es)?”可以匹配“do”或“does”中的“do”。?等價於{0,1}。
      // $1 = (-?\d+) $2 = (\d{3})
      // \d 匹配一個數位字元。等價於[0-9]。
      // {n} n是一個非負整數。匹配確定的n次。例如，“o{2}”不能匹配“Bob”中的“o”，但是能匹配“food”中的兩個o。
      while (pattern.test(num)) {
        num = num.replace(pattern, '$1,$2')
      }
      return num
    },
    numberToChinese (number) {
      /* 单位 */
      const units = '個拾佰仟萬@#%億^&~'
      /* 字符 */
      const chars = '零壹貳參肆伍陸柒捌玖'
      /*
        数字转中文
        @number {Integer} 形如123的数字
        @return {String} 返回转换成的形如 一佰二十三 的字符串
      */
      const a = (number + '').split(''); const s = []
      if (a.length > 12) {
        throw new Error('too big')
      } else {
        for (var i = 0, j = a.length - 1; i <= j; i++) {
          // eslint-disable-next-line eqeqeq
          if (j == 1 || j == 5 || j == 9) { // 两位数 处理特殊的 1*
            // eslint-disable-next-line eqeqeq
            if (i == 0) {
              // eslint-disable-next-line eqeqeq
              if (a[i] != '1') s.push(chars.charAt(a[i]))
            } else {
              s.push(chars.charAt(a[i]))
            }
          } else {
            s.push(chars.charAt(a[i]))
          }
          // eslint-disable-next-line eqeqeq
          if (i != j) {
            s.push(units.charAt(j - i))
          }
        }
      }
      return s.join('').replace(/零([拾佰仟萬億@#%^&~])/g, (m, d) => { // 优先处理 零佰 零仟 等
        const indexOfZeroUnit = units.indexOf(d)
        // eslint-disable-next-line eqeqeq
        if (indexOfZeroUnit != -1) {
          // eslint-disable-next-line eqeqeq
          if (d == '億') return d
          // eslint-disable-next-line eqeqeq
          if (d == '萬') return d
          // eslint-disable-next-line eqeqeq
          if (a[j - indexOfZeroUnit] == '0') return '零'
        }
        return ''
      }).replace(/零+/g, '零').replace(/零([萬億])/g, (m, b) => { // 零佰 零仟处理后 可能出现 零零相连的 再处理结尾为零的
        return b
      }).replace(/億[萬仟佰]/g, '億').replace(/[零]$/, '').replace(/[@#%^&~]/g, (m) => {
        return { '@': '拾', '#': '佰', '%': '仟', '^': '拾', '&': '佰', '~': '仟' }[m]
      }).replace(/([億萬])([壹-玖])/g, (m, d, b) => {
        const indexOfZeroUnit = units.indexOf(d)
        // eslint-disable-next-line eqeqeq
        if (indexOfZeroUnit != -1) {
          // eslint-disable-next-line eqeqeq
          if (a[j - indexOfZeroUnit] == '0') return d + '零' + b
        }
        return m
      })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  /* outline: 1px solid #FA0; */
  box-sizing: border-box;
}
p {
  font-size: 15px;
}
.clearfix {
  display: block;
  clear: both;
}
*{
  font-family: "Century Gothic", Arial, 微軟正黑體, 新細明體, sans-serif;
}
.pageWrap {
  font-family: "Century Gothic", Arial, 微軟正黑體, 新細明體, sans-serif;
  font-size: 13px;
  color: #000;
  display: none;
  .page {
    width: 210mm;
    height: 297mm;
    padding: 20px 15px 0px;
    box-sizing: border-box;
    margin: 0 auto;
    border: 1px #d3d3d3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    position: relative;
    .wrap {
      width: 100%;
      border-bottom: 1px dashed #666;
      box-sizing: border-box;
      position: relative;
      &:last-child {
        border-bottom: none;
      }
      &.top {
        height: 97mm;
        h1 {
          text-align: center;
          font-size: 18px;
          padding: 15px 0 10px;
        }
        h2 {
          text-align: center;
          font-size: 17px;
          padding: 5px 0;
          letter-spacing: 2px;
        }
        .communityDetail {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 270px;
          text-align: left;
          p {
            padding: 4px 0px;
            max-width: 270px;
            word-break: break-all;
          }
          .name {
            font-size: 17px;
          }
        }
        .stamp {
          position: absolute;
          top: 0px;
          right: 20px;
          width: 90px;
          height: 100px;
          border: 1px solid #ccc;
          &:after{
            content: "印刷品";
            display: inline-block;
            position: absolute;
            top: 100px;
            left: 50%;
            transform: translate(-50%, 0);
            width: 100%;
            font-size: 15px;
            line-height: 30px;
            text-align: center;
          }
          .psText {
            width: 100%;
            position: absolute;
            bottom: 15px;
            left: 0;
            p {
              width: 80px;
              padding: 0px 10px 3px;
              margin: 0 auto;
              box-sizing: border-box;
              &.align {
                text-align: left;
                span {
                  float: right;
                }
              }
            }
          }
        }
        .orderDetail {
          position: relative;
          padding-top: 100px;
          padding-left: 250px;
          padding-bottom: 0px;
          width: 100%;
          box-sizing: border-box;
          .qrcodeArea{
            position: absolute;
            width: 105px;
            left: 60px;
            bottom: 0;
            text-align: center;
            img{
              display: inline-block;
              width: 95%;
            }
            span{
              display: inline-block;
              line-height: 1.2;
              margin-top: 3px;
            }
          }
          p {
            max-width: 350px;
            min-height: 35px;
            word-break: break-all;
            &.address {
              margin-bottom: 3px;
              text-align: left;
            }
            &.order {
              text-align: right;
              .name {
                float: left;
              }
              .salutation {
                white-space: nowrap;
              }
            }
          }
        }
        .deadline {
          width: 100%;
          padding: 20px 0 20px 8px;
          box-sizing: border-box;
          text-align: left;
          span {
            letter-spacing: 2px;
            padding-left: 5px;
          }
        }
        .noticePs {
          position: relative;
          margin: 0 auto;
          width: 97%;
          // min-height: 40px;
          height: 62px;
          border: 1px solid #ccc;
          border-radius: 8px;
          overflow: hidden;
          &:after {
            content: "";
            display: block;
            clear: both;
          }
        }
        .title {
          float: left;
          width: 7%;
          height: 100%;
          padding: 5px;
          padding-left: 8px;
          border-right: 1px solid #ccc;
          font-size: 16px;
          line-height: 25px;
          letter-spacing: 5px;
          text-align: center;
          box-sizing: border-box;
        }
        .text {
          float: left;
          width: 92%;
          padding: 5px 10px;
          line-height: 25px;
          box-sizing: border-box;
          text-align: left;
        }
      }
      &.center {
        position: relative;
        height: 96mm;
        padding: 10px 0 10px 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .feePayWrap {
          position: relative;
          float: left;
          width: 48%;
          margin-right: 1.5%;
          padding: 5px 0;
          height: 100%;
          border: 1px solid #ccc;
          border-radius: 10px;
          overflow: hidden;
          box-sizing: border-box;
          .feeTitle {
            display: block;
            width: 100%;
            padding-left: 50px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            text-align: left;
            li {
              display: block;
              font-size: 13px;
              letter-spacing: 2px;
              padding: 3px 0;
              span {
                display: inline-block;
                max-width: 220px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .detailWrap {
            position: relative;
            width: 100%;
            height: 270px;
            padding: 10px 50px 0;
            box-sizing: border-box;
            .itemTilte {
              float: left;
              padding-bottom: 5px;
              border-bottom: 1px solid #ccc;
            }
            .cashTitle {
              float: right;
              padding-bottom: 5px;
              border-bottom: 1px solid #ccc;
            }
            .itemWrap {
              height: 190px;
              overflow: hidden;
              p {
                width: 100%;
                font-size: 13px;
                line-height: 15px;
                padding: 2px 0;
                &:after {
                  content: "";
                  display: block;
                  clear: both;
                }
                .item {
                  float: left;
                }
                .cash {
                  float: right;
                }
              }
            }
            .itemTotal {
              position: relative;
              width: 100%;
              margin-top: 5px;
              padding-top: 5px;
              border-top: 1px dashed #ccc;
              p {
                font-size: 13px;
                margin-bottom: 5px;
                &:after{
                  content: "";
                  display: block;
                  clear: both;
                }
              }
              .totalTitle {
                float: left;
              }
              .totalCash {
                float: right;
              }
            }
          }
        }
        .connectWrap {
          position: relative;
          float: left;
          width: 46%;
          height: 100%;
          border: 1px solid #ccc;
          border-radius: 10px;
          overflow: hidden;
          box-sizing: border-box;
          h3 {
            font-size: 17px;
            letter-spacing: 15px;
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px solid #ccc;
            box-sizing: border-box;
          }
          .connectText {
            padding: 10px 15px;
            height: 240px;
            border-bottom: 1px solid #ccc;
            overflow: hidden;
            box-sizing: border-box;
            text-align: left;
            p {
              font-size: 14px;
              letter-spacing: 2px;
              line-height: 18px;
              margin-bottom: 5px;
              white-space: pre-line;
              word-break: break-all;
            }
          }
          .adWrap {
            width: 100%;
            height: 60px;
            overflow: hidden;
            position: relative;
            img {
              display: block;
              margin: 0 auto;
              height: 45px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translateX(-50%) translateY(-50%);
            }
          }
        }
        .pageText {
          float: right;
          max-width: 3%;
          text-align: center;
          font-size: 14px;
          letter-spacing: 2px;
          line-height: 18px;
        }
      }
      &.bottom {
        height: 96mm;
        .payCodeWrap {
          position: relative;
          width: 100%;
          padding-top: 5px;
          &:after {
            content: "";
            display: block;
            clear: both;
          }
          .formWrap {
            position: relative;
            float: left;
            width: 95%;
            p span {
              letter-spacing: 2px;
            }
            .bankNotice {
              text-align: left;
            }
            .Superbusiness_title {
              position: absolute;
              top: 0px;
              right: 0px;
              font-size: 14px;
              line-height: 18px;
              text-align: center;
            }
            .form {
              position: relative;
              width: 100%;
              margin-top: 5px;
              height: 241px;
              border: 1px solid #ccc;
              .feeData {
                position: relative;
                width: 58%;
                height: 160px;
                float: left;
                .row {
                  position: relative;
                  width: 100%;
                  height: 40px;
                  border-bottom: 1px solid #ccc;
                  .title {
                    float: left;
                    width: 23%;
                    letter-spacing: 5px;
                    line-height: 40px;
                    text-align: center;
                    border-right: 1px solid #ccc;
                  }
                  .data {
                    float: left;
                    width: 77%;
                    font-size: 15px;
                    line-height: 40px;
                    padding-left: 10px;
                    border-right: 1px solid #ccc;
                    span {
                      display: inline-block;
                      vertical-align: top;
                      &.ownerWrap {
                        vertical-align: middle;
                        .owner{
                          word-break: break-all;
                          max-width: 270px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                          -webkit-box-orient: vertical;
                          line-height: 1.1;
                          justify-content: center;
                          align-items: center;
                        }
                      }
                    }
                    .codeArea {
                      position: relative;
                      float: right;
                      width: 175px;
                      height: 40px;
                      margin-right: 10px;
                      padding: 2px 0;
                      p {
                        width: 100%;
                        text-align: center;
                        letter-spacing: 2px;
                        font-size: 12px;
                        line-height: 12px;
                        margin-top: 2px;
                        white-space: nowrap;
                      }
                      img {
                        display: block;
                        width: 100%;
                        height: 22px;
                      }
                    }
                  }
                  .virtualAccount{
                    position: relative;
                    .watermark{
                      position: absolute;
                      top: 50%;
                      left: 72%;
                      transform: translate(-50%, -50%);
                      color: #eb6d6d;
                      opacity: .5;
                      font-size: 50px;
                      writing-mode: vertical-lr;
                      z-index: 9;
                      line-height: 1.2;
                    }
                  }
                  &.certiWrap{
                    width: 172%;
                    height: 80px;
                    p{
                      font-size: 14px;
                      line-height: 1.3;
                      padding: 1px 0 0px 3px
                    }
                    .certiBar{
                      font-size: 22px;
                      font-weight: bold;
                      line-height: 1.7;
                      color: #f12531;
                      padding: 0 13px;
                    }
                    span{
                      letter-spacing: normal;
                    }
                    .content-bold{
                      font-weight: 600;
                    }
                  }
                  .title-sm {
                    display: block;
                    float: left;
                    width: 2%;
                    height: 40px;
                    padding-top: 2px;
                    font-size: 12px;
                    letter-spacing: 1px;
                    border-right: 1px solid #ccc;
                    text-align: center;
                  }
                  .block-sm {
                    height: 100%;
                    width: 97%;
                  }
                  &.price {
                    .data .codeArea{
                      width: 75px;
                      img {
                        width: 70px;
                      }
                      p {
                        width: 70px;
                      }
                    }
                  }
                  &.noATM{
                    height: 160px;
                    .data{
                      width: 100%;
                      height: 100%;
                      position: relative;
                      p{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        font-size: 16px;
                        width: 100%;
                        line-height: 1.2;
                        text-align: center;
                      }
                    }
                  }
                }
              }
              .codeData {
                position: relative;
                width: 42%;
                height: 160px;
                float: left;
                border-bottom: 1px solid #ccc;
                span {
                  display: block;
                  float: left;
                  width: 12%;
                  height: 160px;
                  padding: 10px 5px;
                  font-size: 13px;
                  line-height: 15px;
                  letter-spacing: 1px;
                  text-align: center;
                  border-right: 1px solid #ccc;
                }
                .codeScan {
                  position: relative;
                  float: left;
                  width: 88%;
                  height: 100%;
                  .disablePattern{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 16px;
                    width: 100%;
                    line-height: 1.2;
                    text-align: center;
                  }
                  .watermark{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #eb6d6d;
                    opacity: .5;
                    font-size: 100px;
                    writing-mode: vertical-lr;
                    z-index: 9;
                    line-height: 1.1;
                  }
                  .title {
                    width: 100%;
                    height: 40px;
                    font-size: 13px;
                    line-height: 17px;
                    padding: 3px 10px;
                    text-align: center;
                    border-bottom: 1px solid #ccc;
                  }
                  .code {
                    .codeRow {
                      position: relative;
                      height: 53px;
                      padding: 1px 0 0 8px;
                      img {
                        display: block;
                        max-width: 243px;
                        height: 38px;
                      }
                      p {
                        width: 243px;
                        text-align: center;
                        letter-spacing: 2px;
                        font-size: 12px;
                        line-height: 12px;
                        margin-top: 1px;
                      }
                      &:first-child {
                        img {
                          width: 143px;
                        }
                        p {
                          width: 143px;
                          letter-spacing: 1px;
                        }
                      }
                      .shouldPayMoney {
                        position: absolute;
                        top: 5px;
                        right: 0px;
                        display: inline-block;
                        text-align: center;
                        p {
                          width: 112px;
                          font-size: 12px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .pageText {
            float: right;
            max-width: 3%;
            text-align: center;
            font-size: 14px;
            letter-spacing: 2px;
            line-height: 18px;
          }
          .tip {
            line-height: 17px;
            font-size: 14px;
          }
        }
        .stepWrap {
          width: calc(100% - 3px);
          padding-top: 5px;
          border: 1px solid #ccc;
          margin: 5px 3px 0 0;
          &:after {
            content: "";
            display: block;
            clear: both;
          }
          .stepArea{
            padding: 3px 0 5px 3px;
            p{
              line-height: 1.2;
            }
          }
          .step {
            float: left;
            height: 60px;
            padding: 8px 7px;
            border: 1px solid #ccc;
            border-radius: 10px;
            box-sizing: border-box;
            p {
              font-size: 13px;
              line-height: 17px;
              max-width: 110px;
            }
          }
          .pass {
            float: left;
            width: 30px;
            height: 60px;
            text-align: center;
            padding: 0 5px;
            line-height: 60px;
          }
        }
        .signArea {
          text-align: right;
          font-size: 13px;
          line-height: 17px;
          span {
            display: inline-block;
            height: 20px;
            width: 100px;
          }
        }
        .copyright {
          position: absolute;
          left: 0px;
          bottom: 0px;
          font-size: 13px;
          font-style: italic;
          img {
            display: inline-block;
            margin-left: 5px;
            vertical-align: text-bottom;
            height: 18px;
            transform: translateY(1px);
          }
        }
        .adImg{
          width: 100%
        }
      }
    }
  }
}

.pageWrap.preview {
  display: block;
  .page {
    &:after {
      content:"範本";
      position:absolute;
      display:block;
      width:50%;
      height:50%;
      top:0;
      bottom:0;
      left:0;
      right:0;
      margin:auto;
      color:#eb6d6d;
      opacity:.1;
      text-align:center;
      font-size:200px;
      line-height:1.5;
    }
    .wrap.top {
      .communityDetail {
        border: 2px solid #f12531;
        padding: 0 10px;
        p{
          color:#125687;
          font-weight:600;
        }
      }
      .noticePs{
        border:2px solid #f12531;
        .text{
          color: #125687;
          font-weight: 600;
        }
      }
    }
    .wrap.bottom {
      .bankNameArea {
        border: 2px solid #f12531;
          .bankName {
          border: 0;
          color: #125687;
          font-weight: 600;
        }
      }
    }
  }
}
@page {
  size: 210mm 297mm;
  margin: 0mm;
}
@media print {
  .pageWrap {
    color: #000000;
    box-sizing: border-box;
    display: block;
    .page {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      height: initial;
      box-shadow: initial;
      /* background: initial; */
      page-break-after: always;
      color: #000000;
    }
  }
}
</style>
